export const rootElementId = 'devex-widget';

export const translationConfig = {
  common: [],
  feature: 'Feature.CashOut'
};
